var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70.6533,
    height: 70.6533,
    rx: 12,
    fill: "#FFE5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0587 47.6246H54.4929V51.0587H16.7171V47.6246H20.1512V21.8683C20.1512 21.4129 20.3321 20.9762 20.6542 20.6542C20.9762 20.3322 21.4129 20.1512 21.8683 20.1512H39.0392C39.4946 20.1512 39.9313 20.3322 40.2533 20.6542C40.5753 20.9762 40.7562 21.4129 40.7562 21.8683V47.6246H44.1904V30.4537H49.3417C49.7971 30.4537 50.2338 30.6347 50.5558 30.9567C50.8778 31.2787 51.0587 31.7154 51.0587 32.1708V47.6246ZM27.0196 33.8879V37.3221H33.8879V33.8879H27.0196ZM27.0196 27.0196V30.4537H33.8879V27.0196H27.0196Z",
    fill: "#F70000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnit);
export default __webpack_public_path__ + "static/media/unit.67164dcc648aaa62bd317bfa3b2a92a8.svg";
export { ForwardRef as ReactComponent };